<template>
  <div
    style="float:left;"
    class="org-create-box"
  >
    <a-button
      v-show="!isShow"
      type="primary"
      class="create-org-btn"
      @click.native="createOrg"
    >
      {{ $t('message["129"]') }}
    </a-button>
    <a-form
      v-if="isShow"
      :form="form"
      layout="inline"
      class="demo-form-inline"
      @submit.prevent="creatOrgHandle"
    >
      <a-form-item
        class="total-input-box"
      >
        <a-input
          v-decorator="decorators.comname"
          maxlength="20"
          :placeholder="comnamePlace"
        />
        <span class="input-length-num">{{ form.getFieldValue('comname')?form.getFieldValue('comname').length : 0 }}/20</span>
      </a-form-item>
      <a-form-item class="create-org-form-btn">
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button @click="resetForm">
          {{ $t('message["896"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      isShow: false,
      submiting: false,
      orgNameLen: 0,
      comname: ''
    }
  },
  computed: {
    ...mapState('organization/org', ['submitting', 'decorators']),
    comnamePlace () {
      return this.$t('message["844"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxCreateOrg']),
    createOrg () {
      this.isShow = true
    },
    creatOrgHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.ajaxCreateOrg()
          chain.params(values)
            .setForm(this.form)
            .fetch()
          this.isShow = false
          this.$emit('reset')
        }
      })
    },
    resetForm () {
      this.isShow = false
      this.$emit('reset')
    },
    getValLen (val) {
      let str = val.replace(/^\s+|\s+$/g, '')
      this.orgNameLen = str.length
    }

  }
}
</script>

<style lang="scss" scoped>
  .org-create-box::v-deep  {
    .total-input-box {
      position: relative;
      .input-length-num {
        position: absolute;
        right: 12px;
        color: #b3b3b3
      }
      .ant-input {
        padding-right: 50px;
      }
    }
    .create-org-form-btn {
      margin-right: 0 !important;
      .ant-btn-default{
        margin-right: 0;
      }
    }
  }
</style>
